import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Projects/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ProjectsQueries extends VueCqrs
{
	runProjectPlansQueryV1(workspaceId: number, tchProjectId: number, projectId: string)
	{
		const query = q.buildProjectPlansQueryV1(workspaceId, tchProjectId, projectId);
		this.$query(query);
	}

	runProjectPlanByIdQueryV1(workspaceId: number, portfolioId: string, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectPlanByIdQueryV1(workspaceId, portfolioId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectRevenuesQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectRevenuesQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectMarginsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectMarginsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectExpenseAllocationsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectExpenseAllocationsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectExpenseSavingsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectExpenseSavingsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectResourceAllocationsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectResourceAllocationsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectResourceSavingsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectResourceSavingsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectResourceUnitCostsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectResourceUnitCostsQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}

	runProjectCapexQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
	{
		const query = q.buildProjectCapexQueryV1(workspaceId, tchProjectId, projectId, projectPlanId);
		this.$query(query);
	}


	runProjectPlanPnlQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string, pnlId: string | null,
		applyBenefitsConfidenceFactor: boolean, denomination: string | null)
	{
		const query = q.buildProjectPlanPnlQueryV1(workspaceId, tchProjectId, projectId, projectPlanId, pnlId, applyBenefitsConfidenceFactor, denomination);
		this.$query(query);
	}

	runMyPortfolioProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
	{
		const query = q.buildMyPortfolioProjectsPageQueryV1(workspaceId, tchProjectId);
		this.$query(query);
	}

	runGridProjectByIdQueryV1(workspaceId: number, portfolioId: string, projectId: string)
	{
		const query = q.buildGridProjectByIdQueryV1(workspaceId, portfolioId, projectId);
		this.$query(query);
	}
}